interface IUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  designation: string;
  onboarding: 'verification'|'company'|'completed';
  verified: boolean,
  companies: {company: string, role: string}[],
  isAdmin: boolean,
  via?: string,
  marketingConsent?: {
    status: boolean,
    updatedAt?: string,
    source?: string,
  },
  createdAt: string,
}

export enum SignUpSource {
  GOOGLE = 'google',
  LOCAL = 'local',
}

export const UserDesignations = [
  { value: 'pm', label: 'Product Manager' },
  { value: 'dev', label: 'Developer / Engineer' },
  { value: 'ops', label: 'Operations / IT Manager' },
  { value: 'ux', label: 'UX/UI Designer' },
  { value: 'data', label: 'Data Analyst / Scientist' },
  { value: 'marketing', label: 'Marketing Manager / Director' },
  { value: 'founder', label: 'Founder / CEO / Executive' },
  { value: 'other', label: 'Other' },
];

export default IUser;
